import { Injectable } from "@angular/core";
import { AuditLogInput } from "@app/audit-log/models/audit-log-type.model";
import { AuditLogService } from "@app/audit-log/services/audit-log.service";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { CLARE_HOME_METHODS, ClareHomeRPCMethodNames, ClareHomeRPCServiceNames } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

@Injectable({
    providedIn: "root",
})
export class EquatorClareHomeService {
    constructor(readonly equatorProxyService: EquatorProxyService, private tsLoggingService: AuditLogService) {}

    private call(uuid: string, method: ClareHomeRPCMethodNames, params: any[], logInput?: AuditLogInput) {
        return this.equatorProxyService
            .makeClareHomeRpcRequest$(
                uuid, // uuid
                ClareHomeRPCServiceNames.CLARE_HOME, // service
                method, // method
                params // params
            )
            .pipe(tap(_ => this.saveAuditLog(logInput)));
    }

    public getServerInfo(uuid: string): Observable<any> {
        return this.call(uuid, CLARE_HOME_METHODS.GET_SERVER_INFO, []);
    }

    public restartController(uuid: string, logInput?: AuditLogInput) {
        return this.call(uuid, CLARE_HOME_METHODS.REBOOT, [uuid], logInput);
    }

    public getTimezone(uuid: string): Observable<any> {
        return this.getServerInfo(uuid).pipe(map(serverInfo => serverInfo?.timezone || "Unknown"));
    }

    public getControllerModel(uuid: string): Observable<any> {
        return this.getServerInfo(uuid).pipe(map(serverInfo => serverInfo?.machineModel || "Unknown"));
    }

    public verifySerialNumber(uuid: string, serialNumber: string): Observable<any> {
        return this.call(uuid, CLARE_HOME_METHODS.VERIFY_SERIAL_NUMBER, [serialNumber]);
    }

    public restartBundle(uuid: string, bundleName: string, logInput?: AuditLogInput) {
        return this.call(uuid, CLARE_HOME_METHODS.RESTART_BUNDLE, [bundleName], logInput);
    }

    private saveAuditLog(logData: AuditLogInput) {
        if (logData) {
            const { auditName, ...log } = logData;
            if (auditName && log) {
                this.tsLoggingService.logEvent(auditName, log);
            }
        }
    }
}
